"use client";

import React from "react";
import Image from "next/image";

import { cn } from "@/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

type JavaChampionBadgeProps = {
  className?: string;
};

export function JavaChampionBadge({ className }: JavaChampionBadgeProps) {
  const handleStopPropagation = (
    event:
      | React.MouseEvent<HTMLButtonElement>
      | React.KeyboardEvent<HTMLButtonElement>
      | React.FocusEvent<HTMLButtonElement>,
  ) => {
    event.stopPropagation();
  };

  return (
    <Tooltip interaction="toggle">
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Java Champion"
          className={cn(
            "border-border inline-flex size-7 items-center justify-center rounded-full border bg-white shadow-sm dark:bg-[#454545]",
            className,
          )}
          onBlur={handleStopPropagation}
          onClick={handleStopPropagation}
          onFocus={handleStopPropagation}
          onKeyDown={handleStopPropagation}
          onKeyUp={handleStopPropagation}
        >
          <Image
            alt="Java Champion"
            className="size-5"
            height={14}
            src="/java-champion.png"
            width={14}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent>Java Champion</TooltipContent>
    </Tooltip>
  );
}
